import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const UsersPage = lazy(() => import('./UsersPage'));

const routes: RouteObject[] = [
  { path: '/users', element: <Guard any={['user.read', 'role.read']}><UsersPage /></Guard> },
];
export default routes;
